import AppConstants from '../constants/app.constants'
import router from '../router'
import { store } from '../store'
export default class RouterUtils {
  static goToRouterPath(path) {
    router.push(path).catch(error => {
      this._ignoreNavDuplicated(error)
    })
  }

  static goToRouterName(routerName) {
    router.push({ name: routerName }).catch(error => {
      this._ignoreNavDuplicated(error)
    })
  }

  static goToRouterQuery(queryObj) {
    router.push({ query: queryObj }).catch(error => {
      this._ignoreNavDuplicated(error)
    })
  }

  static _ignoreNavDuplicated(error) {
    if (
      !error && error.name !== 'NavigationDuplicated' &&
      !error.message.includes(
        'Avoided redundant navigation to current location'
      )
    ) {
      console.log(error)
    }
  }

  static getFirstChildRoutePath(route, mstMenu) {
    let firstRoute = null
    if (!route) {
      return null
    }
    let childrenRoute = route.children
    if (!childrenRoute || childrenRoute.length === 0) {
      return null
    }
    if (store.getters['useCaseSelection/isOnlyNoTaskSortUseCase']) {
      switch (route.path) {
        case 'master':
          childrenRoute = this.getCurrentChildrenRoute(childrenRoute, AppConstants.NO_TASK_SORT_HIDDEN_MASTER_PATHS)
          break
        case 'mapping':
          childrenRoute = this.getCurrentChildrenRoute(childrenRoute, AppConstants.NO_TASK_SORT_HIDDEN_MAPPING_PATHS)
          break
        default:
          break
      }
    }
    let visibleFlag = null
    for (let key in childrenRoute) {
      visibleFlag = mstMenu[childrenRoute[key].name]
      if (visibleFlag) {
        firstRoute = childrenRoute[key].path
        break
      }
    }
    return firstRoute
  }

  static getRouteWithFullOptions(allRoutes, routeName) {
    const mainRoute = allRoutes.filter(s => s.meta.name === AppConstants.MAIN_CONTENT_ROUTER_NAME)[0]
    if (!mainRoute) {
      return null
    }
    const parentRoute = mainRoute.children.filter(route => route.name === routeName)[0]
    return parentRoute
  }

  static getParentRoute(route) {
    const parentRoute = route.matched.filter(route => route.meta.name !== AppConstants.MAIN_CONTENT_ROUTER_NAME)[0]
    return parentRoute
  }

  static getQueryString(routeName) {
    let queryStr = ''
    const queryObj = this.getQueryObjectFromStorage()
    // dispatch on url
    history.replaceState('', '', location.href.replace(/[?].+/, '') + queryObj[routeName] || '')
    queryStr = queryObj[routeName]
    return queryStr
  }

  static getQueryObjectFromStorageByRouterName(routeName) {
    if (!routeName) {
      return {}
    }
    const queryObjectInStorage = this.getQueryObjectFromStorage()
    let querystring = ''
    if (queryObjectInStorage) {
      querystring = queryObjectInStorage[routeName]
    }
    // Parse query string
    const params = new URLSearchParams(querystring)
    const queryObject = {}
    // Iterate over all keys
    for (const key of params.keys()) {
      if (params.getAll(key).length > 1) {
        queryObject[key] = params.getAll(key)
      } else {
        queryObject[key] = params.get(key)
      }
    }
    return queryObject
  }

  static getQueryObjectFromStorage() {
    return JSON.parse(localStorage.getItem(AppConstants.STORAGE_QUERY_OBJECT))
  }

  /**
   * Update queryStr into query object of localStorage by routeName.
   * @param {*} routeName
   * @param {*} value
   */
  static updateQueryObjectToStorage(routeName, value) {
    const queryObj = this.getQueryObjectFromStorage() || {}
    if (queryObj) {
      queryObj[routeName] = value || ''
      localStorage.setItem(AppConstants.STORAGE_QUERY_OBJECT, JSON.stringify(queryObj))
    }
  }

  /**
   * Initialize the query object into localStorage according
   * to the current routeName with the query string being empty.
   * @param {*} routeName
   * @param {*} emptyStr
   * @returns
   */
  static initQueryObjectInStorage(routeName, emptyStr) {
    let queryObj = this.getQueryObjectFromStorage() || {}
    // when there is a query object that does not key exist a key name matching the current routeName
    if (!queryObj.hasOwnProperty(routeName)) {
      queryObj[routeName] = emptyStr
      localStorage.setItem(AppConstants.STORAGE_QUERY_OBJECT, JSON.stringify(queryObj))
    }
  }

  /**
   * URLの置換処理
   * @param {*} replaceStr
   */
  static replaceUrlStr(replaceStr) {
    let replaceUrl = location.href.replace(/[?].+/, '')
    history.replaceState('', '', replaceUrl + replaceStr)
  }

  /**
   * クエリ文字列をオブジェクトに変換します
   * @param {*} querystring
   * @returns クエリオブジェクト
   */
  static parseQueryToObject(querystring) {
    const queryObject = {}
    if (!querystring) {
      return queryObject
    }
    // Parse query string
    const params = new URLSearchParams(querystring)
    // Iterate over all keys
    for (const key of params.keys()) {
      if (params.getAll(key).length > 1) {
        queryObject[key] = params.getAll(key)
      } else {
        queryObject[key] = params.get(key)
      }
    }
    return queryObject
  }

  /**
   * クエリオブジェクトを文字列に変換します
   * @param {*} queryObject URLのクエリオブジェクト
   * @returns クエリ文字列
   */
  static convertQueryObjectToString(queryObject) {
    return Object.keys(queryObject || {})
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`)
      .join('&')
  }

  /**
   * 正しいテーブル行制限パラメーター
   * @param {*} queryObj URLのクエリオブジェクト
   */
  static correctTableRowsLimitParam(queryObj) {
    // eslint-disable-next-line no-undef
    if (queryObj && queryObj['limit'] > config.TABLE_ROWS_LIMIT) {
      // eslint-disable-next-line no-undef
      queryObj['limit'] = config.TABLE_ROWS_LIMIT
      this.replaceUrlStr(`?${this.convertQueryObjectToString(queryObj)}`)
    }
  }

  /**
   * パラメータを変換して URL をエンコードする
   * @param {*} param パラメータ
   * @returns URL をエンコードする
   */
  static encodedUrlParam(param) {
    return encodeURIComponent(param)
  }

  /**
   * オブジェクトにプロパティが存在することを確認する
   * @param {*} routerName ルーター名
   * @param {*} prop オブジェクトからのプロパティ
   * @returns true: 存在する、false: 存在しない
   */
  static existedPropertyQueryObjectFromStorageByRouterName(routerName, prop) {
    return this.getQueryObjectFromStorageByRouterName(routerName).hasOwnProperty(prop)
  }

  /**
   * URL のパラメーターを取得
   * @param   {*} fullPath フルパス
   * @returns {object}     URL のパラメータ
   */
  static getUrlParam(fullPath) {
    if (!fullPath) {
      return null
    }
    const params = fullPath.match(/\?.+/)
    return this.parseQueryToObject(params && params[0])
  }
  /**
   * バッチ詳細表示フラグを削除
   * @param   {string} routeName ルーター名
   */
  static removeSearchExacFromStorage(routeName) {
    const queryString = this.getQueryString(routeName)
    this.updateQueryObjectToStorage(routeName, queryString.replace(/&showBatchDetails=true/g, ''))
  }

  /**
   * 非表示パスのリストに基づいて現在の子ルートをフィルタリングして返します。
   *
   * @param {Array} routeChildren 子ルーターオブジェクトを含む配列
   * @param {Array} hiddenPaths 非表示と見なされるパス名の配列
   * @returns {Array} 非表示でない子ルートを表すルーター オブジェクトの配列
   */
  static getCurrentChildrenRoute(routeChildren, hiddenPaths) {
    if (!routeChildren || !hiddenPaths) {
      return []
    }
    return routeChildren.filter(
      child => child && child.name && !hiddenPaths.includes(child.name)
    )
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/router.util.js